import FeatureGates from '@atlaskit/feature-gate-js-client/feature-gates';
import { fetchJson } from '@atlassian/help-center-common-util/fetch';
import { contextPath } from '@atlassian/help-center-common-util/history';
import type {
	CmdbObjectHttpResponse,
	CmdbObjectResponse,
	CmdbObjectDetailsHttpResponse,
	CmdbObjectAttribute,
} from './types';

export const fetchCmdbObjectDetails = (
	requestKey: string,
	fieldId: string,
	objectGlobalId: string,
	signal?: AbortSignal,
): Promise<CmdbObjectAttribute[]> =>
	fetchJson<CmdbObjectDetailsHttpResponse>(
		`${contextPath}/rest/servicedesk/1/customer/request/${requestKey}/cmdb/field/${fieldId}/object/${objectGlobalId}`,
		{ signal, method: 'GET' },
	).then(({ attributes }) => attributes ?? []);

export const fetchCmdbObjectsWithSignal = (
	portalId: number,
	requestTypeId: number,
	fieldId: string,
	inputValue: string,
	fieldValueMap: string[][],
	signal: AbortSignal,
	start: number,
	includeAssignScope = true,
): Promise<CmdbObjectResponse> => {
	const fieldValueMapObject = fieldValueMap.reduce(
		(accumulator: Record<string, string>, field: [string, string]) => {
			if (field[0] !== 'attachment') {
				accumulator[field[0]] = field[1];
			}
			return accumulator;
		},
		{},
	);

	const body = {
		query: inputValue,
		fieldValueMap: fieldValueMapObject,
	};

	const assignScopeQuery = FeatureGates.checkGate('assets_custom_field_ui_assign_strict_scope')
		? `&includeAssignScope=${String(includeAssignScope)}`
		: '';

	return fetchJson<CmdbObjectHttpResponse>(
		`${contextPath}/rest/servicedesk/cmdb/1/customer/portal/${portalId}/request/${requestTypeId}/field/${fieldId}/autocomplete?start=${start}${assignScopeQuery}`,
		{
			signal,
			method: 'POST',
			body: JSON.stringify(body),
			headers: { 'Content-Type': 'application/json' },
		},
	).then(({ results, total, hasNextPage }: CmdbObjectHttpResponse) => ({
		total,
		hasNextPage,
		cmdbObjects: results,
	}));
};
